import { useEffect } from 'react';
import { useAuthStore } from '@/store/useAuthStore';
import { useGamificationStore } from '@/store/useGamificationStore';
import { gamificationApi } from '@/services/api';

export function useSyncGamification() {
  const { isAuthenticated, user } = useAuthStore();
  const syncFromServer = useGamificationStore((s) => s.syncFromServer);

  useEffect(() => {
    if (!isAuthenticated || !user?.id) return;

    gamificationApi
      .getProgress(user.id)
      .then(({ data }) => {
        syncFromServer({
          totalXp: data.totalXp ?? 0,
          level: data.level ?? 1,
          currentStreak: data.currentStreak ?? 0,
        });
      })
      .catch(() => {});
  }, [isAuthenticated, user?.id, syncFromServer]);
}
